/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Agents_Tools_LabelInputs */

const en_cad_agents_tools_label = /** @type {(inputs: Cad_Agents_Tools_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP tools`)
};

/**
* | output |
* | --- |
* | "MCP tools" |
*
* @param {Cad_Agents_Tools_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_agents_tools_label = /** @type {((inputs?: Cad_Agents_Tools_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Agents_Tools_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_agents_tools_label(inputs)
});
export { cad_agents_tools_label as "cad.agents.tools_label" }